import ComponentArrasteSolte from 'models/componentInteraction/ComponentArrasteSolte';
import { GenericService } from '../Generic.service';

export class ComponentArrasteSolteService extends GenericService {
    readonly URI: string = '/v1/componentArrasteSolte';

    constructor() {
        super();
        this.setUri(this.URI);
    }

    async saveComponent(idInteraction: number, model: ComponentArrasteSolte) {
        return await this.post('' + idInteraction, model);
    }

    async updateComponent(idInteraction: number, model: ComponentArrasteSolte) {
        return await this.put('' + idInteraction, model);
    }
    async deleteQuestion(idQuestion: number) {
        return await this.deleteByUrl(idQuestion, 'question');
    }
    async deleteAlternativa(idAlternativa: number) {
        return await this.deleteByUrl(idAlternativa, 'alternativa');
    }
}
